<div class="max-form-width">
  <h2 mat-dialog-title>Add Queue</h2>

  <mat-dialog-content fxLayoutGap="20px">
    <div fxLayout="row" fxFlexAlign="center center" fxLayoutGap="10px">
      <mat-form-field class="name-field">
        <mat-label>Name</mat-label>
        <input type="text" matInput [(ngModel)]="name" placeholder="Queue Name - same as in azure service bus">
      </mat-form-field>
    </div>

    <hr>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div fxLayout="column" fxFill>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
        <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaveDisabled">
          <mat-icon>done</mat-icon> Save
        </button>
        <button mat-stroked-button color="basic" aria-label="Cancel" (click)="close()">
          <mat-icon>clear</mat-icon> Cancel
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>